import { useEffect, useRef } from 'react';
import { useNotifications } from './useNotifications';

/**
 * Observa `queue` e dispara notificação nativa quando entra item novo.
 * `onNotificationClick` — callback chamado ao clicar na notificação (ex: mudar aba para fila)
 */
export function useQueueNotifier(queue, onNotificationClick) {
  const { notify } = useNotifications();
  const prevIds = useRef(new Set(queue.map(i => i.id)));

  useEffect(() => {
    const currentIds = new Set(queue.map(i => i.id));
    const newItems = queue.filter(i => !prevIds.current.has(i.id));

    if (newItems.length > 0) {
      const first = newItems[0];
      notify(
        `Nova conversa na fila (${queue.length})`,
        `${first.customer}: ${first.preview || ''}`,
        onNotificationClick
      );
    }

    prevIds.current = currentIds;
  }, [queue, notify, onNotificationClick]);
}
